/**
A strongly-typed version of `Object.hasOwn()`.

https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/hasOwn
*/
export const objectHasOwn = <T, K extends PropertyKey>(ob: T, key: K): ob is T & Record<K, unknown> => {
  return Object.prototype.hasOwnProperty.call(ob, key);
};
